// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-padding-modal-video .ant-modal-close {
  display: none;
}
.no-padding-modal-video .ant-modal-body {
  padding: 0 !important;
}
.no-padding-modal-video .ant-modal-content {
  background-color: transparent;
  box-shadow: none;
}
#integration-motivation-modal-large {
  min-height: 100%;
  min-width: 100%;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  border-radius: 1.25rem;
  background-color: transparent !important;
}
#integration-motivation-modal-thin {
  min-height: 100%;
  min-width: 100%;
  height: 100%;
  right: 0;
  left: 0;
  top: 0;
  bottom: 0;
  border-radius: 1.25rem;
  background-color: transparent !important;
}
div.content iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  border-radius: 1.125rem;
}
.video-large {
  position: relative;
  width: 100%;
  padding-bottom: 56.25% !important;
}
div.content-thin iframe {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  border-radius: 1.125rem;
}
.video-thin {
  position: relative;
  width: 100%;
  padding-bottom: 178.25% !important;
  max-width: 768px;
}
`, "",{"version":3,"sources":["webpack://./src/components/modals/IntegrationVideoMotivationModal/styles.less"],"names":[],"mappings":"AAAA;EAEI,aAAA;AAAJ;AAFA;EAKI,qBAAA;AAAJ;AALA;EAQI,6BAAA;EACA,gBAAA;AAAJ;AAIA;EACE,gBAAA;EACA,eAAA;EACA,QAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,sBAAA;EACA,wCAAA;AAFF;AAIA;EACE,gBAAA;EACA,eAAA;EAEA,YAAA;EACA,QAAA;EACA,OAAA;EACA,MAAA;EACA,SAAA;EACA,sBAAA;EACA,wCAAA;AAHF;AAMA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,uBAAA;AAJF;AAOA;EACE,kBAAA;EACA,WAAA;EACA,iCAAA;AALF;AAQA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,OAAA;EACA,SAAA;EACA,uBAAA;AANJ;AASE;EACE,kBAAA;EACA,WAAA;EACA,kCAAA;EACA,gBAAA;AAPJ","sourcesContent":[".no-padding-modal-video {\n  .ant-modal-close {\n    display:none;\n  }\n  .ant-modal-body {\n    padding:0 !important;    \n  }\n  .ant-modal-content {\n    background-color:transparent;\n    box-shadow:none;\n  }\n}\n\n#integration-motivation-modal-large { \n  min-height:100%;\n  min-width:100%;\n  right:0;\n  left:0;\n  top:0;\n  bottom:0;\n  border-radius:1.25rem;\n  background-color:transparent !important;\n}\n#integration-motivation-modal-thin { \n  min-height:100%;\n  min-width:100%;\n \n  height:100%;\n  right:0;\n  left:0;\n  top:0;\n  bottom:0;\n  border-radius:1.25rem;\n  background-color:transparent !important;\n}\n\ndiv.content iframe {\n  width:100%;\n  height:100%;\n  position: absolute;\n  top:0;\n  right:0;\n  left:0;\n  bottom:0;\n  border-radius:1.125rem;\n}\n\n.video-large {\n  position: relative;\n  width:100%;\n  padding-bottom: 56.25% !important;\n}\n\ndiv.content-thin iframe {\n    width:100%;\n    height:100%;\n    position: absolute;\n    top:0;\n    right:0;\n    left:0;\n    bottom:0;\n    border-radius:1.125rem;\n  }\n\n  .video-thin {\n    position: relative;\n    width:100%;\n    padding-bottom: 178.25% !important;\n    max-width:768px;\n  }\n  \n@xs-screen: 480px;@sm-screen: 576px;@md-screen: 768px;@lg-screen: 992px;@xl-screen: 1200px;@xxl-screen: 1600px;@content-max-width: 1598px;@border-radius: 1.25rem;"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
